import { HeroButton } from "./button";
import FileUpload from "./FileUpload";
import InputField from "./inputField";

const RequestProposalForm = () => {
  return (
    <div className="mt-6 md:mt-12 bg-white rounded-[12px] md:rounded-[24px] px-5 md:px-10 lg:px-[100px] py-5 md:py-10 lg:py-20 space-y-6 md:space-y-8 w-full">
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Company Name"
          placeholder="Enter your company name"
        />
        <InputField
          label="Project Name & Location"
          placeholder="Enter project name & location"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Email Address"
          placeholder="Enter your email address"
          type="email"
        />
        <InputField
          label="Phone Number"
          placeholder="Enter your phone number"
          type="tel"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Type of Development"
          placeholder="Select type of development"
          as="select"
          options={[]}
        />
        <InputField
          label="Number of Units"
          placeholder="Enter the number of units"
          type="number"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Expected Delivery Timeline"
          placeholder="Enter expected delivery timeline"
        />
        <InputField label="Contact Person" placeholder="Enter contact person" />
      </div>

      <FileUpload
        label=" Upload Project Drawings (PDF/DWG)"
        description=" Upload authorization letter
"
        accept=".pdf,.doc,.docx, jpeg, png"
        maxSize={10}
        size="large"
        onChange={(file) => console.log(file)}
      />

      <div className="flex justify-center pt-5">
        <HeroButton title="Submit Proposal" />
      </div>
    </div>
  );
};

export default RequestProposalForm;
